import { FileDataConnectorViewModel } from '../views/connectors/file/file-data-connector/file-data-connector.component';
import DatabaseType, { DataConnectorType, DataConnectorTypeIngest } from '../domainObjects/dataConnector';
import { DataSourceType } from '../domainObjects/dataSourceType';
import { IngestConfigViewModel } from '../views/import-data/import-data.component';
import { ColumnMapDefinitionModel } from '../model/columnMapDefinitionModel';
import { ImportDataViewModel } from './importDataViewModel';
import { TransformerViewModel, TransformListViewModel } from '../views/transformer-list/transformer-list.component';
import { DataTransformerConfig, IngestTransformerConfig } from '../domainObjects/dataTransformConfig';
import { DataFarmType } from '../domainObjects/dataFarmType';
import { ExcelDataConnectorViewModel } from '../views/connectors/excel/excel-data-connector/excel-data-connector.component';
import { UserDataService } from '../services/user-data-service';
import { DataTypeConverter, DeduplicateRows, DurationBuilder, GeneralParameter } from '../domainObjects/ingestTransforms';
import { FeatherDataConnectorViewModel } from '../views/connectors/feather/feather.component';
import { DatabaseDataConnectorViewModel } from '../views/connectors/database/sql-data-connector/sql-data-connector.component';
import { OracleDataConnectorViewModel } from '../views/connectors/database/oracle-data-connector/oracle-data-connector.component';
import { MySqlDataConnectorViewModel } from '../views/connectors/database/mysql-data-connector/mysql-data-connector.component';
import { VerticaDataConnectorViewModel } from '../views/connectors/database/vertica-data-connector/vertica-data-connector.component';
import { ParquetDataConnectorViewModel } from '../views/connectors/parquet-data-connector/parquet-data-connector.component';

export class DataTransformConfigViewModel {
    name: string;
    selectedIngestFarmGuid?: string;
    activeTransformGuid?: string; // current Transform Detail View
    dataSourceType?: DataSourceType;
    dataConnectorType?: DataConnectorType;
    databaseType?: DatabaseType;
    databaseDataConnectorViewModel?: DatabaseDataConnectorViewModel;
    oracleDataConnectorViewModel?: OracleDataConnectorViewModel;
    verticaDataConnectorViewModel?: VerticaDataConnectorViewModel;
    mySqlDataConnectorViewModel?: MySqlDataConnectorViewModel;
    fileDataConnectorViewModel?: FileDataConnectorViewModel;
    excelDataConnectorViewModel?: ExcelDataConnectorViewModel;
    featherDataConnectorViewModel?: FeatherDataConnectorViewModel;
    parquetDataConnectorViewModel?: ParquetDataConnectorViewModel;
    isDataValid = false;
    columnDefinitions: ColumnMapDefinitionModel[];
    ingestConfigs: IngestConfigViewModel[] = [];
    transforms: TransformerViewModel[] = [];
    dataTransformerConfig?: DataTransformerConfig;
    subTaskTransforms = new TransformListViewModel();
    taskTransforms = new TransformListViewModel();
    activityTransforms = new TransformListViewModel();

    dataConnectorTypeIngest?: DataConnectorTypeIngest;
    ingestTransformerConfig = new IngestTransformerConfig();
    
    DataTypeConverter?: DataTypeConverter;
    DurationBuilder?: DurationBuilder;
    DeduplicateRows?: DeduplicateRows;
    GeneralParameter?: GeneralParameter;

    constructor(  dataTransformConfig?: DataTransformerConfig) {
      //console.log('creating DataTransformConfigViewModel');
      //console.log(dataTransformConfig);

      if (dataTransformConfig) {
        this.dataTransformerConfig = dataTransformConfig;
        this.dataSourceType = dataTransformConfig.dataSourceType;
        this.name = dataTransformConfig.name;
        this.selectedIngestFarmGuid = dataTransformConfig.selectedIngestFarmGuid;
        // this.userData = userData;
        // const configJsonObject = userData.getSelectedConfigJson(); //state.config;
        // Build ingests configs
        dataTransformConfig.dataConnectorMappings?.forEach(d => {
          const ingestConfigVM = new IngestConfigViewModel(
            d,
            d.columnMap?.map(i => i.sourceColumn),
            dataTransformConfig.transforms?.filter(t => t.dataFarmType === DataFarmType.ingest), dataTransformConfig);

          this.ingestConfigs.push(ingestConfigVM);
        });
        //console.log('dataTransformConfig.dataConnectorMappings',dataTransformConfig.dataConnectorMappings);
        //console.log('this.ingestConfigs',this.ingestConfigs);
        // Build transforms
        this.transforms = dataTransformConfig.transforms.map(t => new TransformerViewModel(t));

        this.subTaskTransforms = new TransformListViewModel(dataTransformConfig.transforms
          .filter(t => t.dataFarmType === DataFarmType.subTask));

        this.taskTransforms = new TransformListViewModel(dataTransformConfig.transforms
          .filter(t => t.dataFarmType === DataFarmType.task));

        this.activityTransforms = new TransformListViewModel(dataTransformConfig.transforms
          .filter(t => t.dataFarmType === DataFarmType.activity));

        this.DataTypeConverter = dataTransformConfig.dataTypeConverter;
        this.DurationBuilder = dataTransformConfig.durationBuilder;
        this.DeduplicateRows = dataTransformConfig.deduplicateRows;
        this.GeneralParameter = dataTransformConfig.generalParameter;
      }
    }

    toImportDataViewModel(): ImportDataViewModel {
      const importDataViewModel = new ImportDataViewModel();

      importDataViewModel.dataConnectorType = this.dataConnectorType;
      importDataViewModel.databaseType = this.databaseType;
      importDataViewModel.dataSourceTypeId = this.dataSourceType;
      importDataViewModel.columns = this.columnDefinitions;

      importDataViewModel.DataTypeConverter = this.DataTypeConverter;
      importDataViewModel.DurationBuilder = this.DurationBuilder;
      importDataViewModel.DeduplicateRows = this.DeduplicateRows;
      importDataViewModel.GeneralParameter = this.GeneralParameter;

      switch (this.dataConnectorType) {
        case DataConnectorType.Text:
          importDataViewModel.dataConnector = this.fileDataConnectorViewModel;
          break;
        case DataConnectorType.Excel:
          importDataViewModel.dataConnector = this.excelDataConnectorViewModel;
          break;
        case DataConnectorType.Feather:
          importDataViewModel.dataConnector = this.featherDataConnectorViewModel;
          break;
           case DataConnectorType.Parquet:
          importDataViewModel.dataConnector = this.parquetDataConnectorViewModel;
          break;
        case DataConnectorType.Database:
          if(this.databaseType == DatabaseType.SQL){
            importDataViewModel.dataConnector = this.databaseDataConnectorViewModel;
          }else if(this.databaseType == DatabaseType.Oracle){
            importDataViewModel.dataConnector = this.oracleDataConnectorViewModel;
          }
          else if(this.databaseType == DatabaseType.MySql){
            importDataViewModel.dataConnector = this.mySqlDataConnectorViewModel;
          }
          else if(this.databaseType == DatabaseType.Vertica){
            importDataViewModel.dataConnector = this.verticaDataConnectorViewModel;
          }
          break;
      }
      return importDataViewModel;
    }
}
